import { Badge, Tag } from 'antd'

import { StrictOmit } from '../../../../types/utilities'
import { FieldStatusProps } from '../../interface'

export const FieldStatus = ({
  className,
  style,
  color,
  value,
  tag
}: StrictOmit<FieldStatusProps, 'type'>) => {
  return tag ? (
    <Tag className={className} color={color} style={style} variant='filled'>
      {value}
    </Tag>
  ) : (
    <Badge color={color}>{value}</Badge>
  )
}
